export default __webpack_public_path__ + "static/client4-6f8f35729391843fbf27683f353a5b07.png";